
import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import classnames from 'classnames'
import { SavedJobsButton } from './SavedJobsButton'
import { useLocalStorage } from './../hooks/useLocalStorage'
import { unique } from './../utility/array'
import { filter } from './../utility/object'


export function Job({ 
	job, 
	searchUrl, 
	small = false, 
	showLink = true, 
	showPosted = true,
	showSave = true, 
	showEmploymentType = true,
	showDescription = false,
	statusParam = false,
	...props 
}) {

	const classes = classnames(
		'single-job text-blue', 
		small && 'single-job--small',
		job.Featured && 'featured',
		props['class'], props['className']
	)

	delete props['class']
	delete props['className']

	const [jobs, setSaved] = useLocalStorage('savedJobs', {})
	const saved = jobs[job.Id] || false

	const save = () => {
		const record = {
			id : job.Id,
			title : job.AssignmentAltName || job.AssignmentName,
			subtitle : job.Company,
			href : job.post_url
		}
		setSaved({...jobs, [job.Id] : record })
	}

	const unsave = () => {
		setSaved({ ...jobs, [job.Id] : undefined })
	}

	const location = unique([
		job.TownCity || job.PostcodeDistrict,
		job.PostcodeRegion
	].filter(Boolean)).join(', ')
	
	const imageLinkClasses = classnames(
		'single-job__thumb',
		'logo-box',
		job.AssignmentLogoMargin && 'logo-box--inset',
	)

	const hasCompany = !!job.CompanyId

	const companyUrl = `${searchUrl}?` + new URLSearchParams(filter({
		companyId: job.CompanyId || undefined,
		status: statusParam || undefined
	})).toString()

	const image = job.AssignmentLogo && <>
		<img 
	    	src={job.AssignmentLogo || undefined} 
	    	srcset={job.AssignmentLogoSrcSet || undefined} 
	    	sizes="200px" 
	    	alt={job.Company}
	    />
	</>

	return <>
		 <div class={classes}>
	        <div class="single-job__details">
	            <div class="first-last">

	            	{showLink && <>
	            		<h4 class="heading-6"><a href={job.post_url} class="underline underline--blue">{job.AssignmentAltName || job.AssignmentName}</a></h4>
	            	</> || <>
	            		<h4 class="heading-6">{job.AssignmentAltName || job.AssignmentName}</h4>
	            	</> }
	                
	                <p class="margin-0">
	                	{showPosted && <span class="single-job__posted">{`${job.Timeago}${hasCompany ? ' by' : ''}`}&nbsp;</span>}
	                	{hasCompany && <span class="single-job__company"><a class="underline underline--thin underline--grey" href={companyUrl}>{job.Company}</a></span>}
	                </p>
		            <ul class="single-job__meta">
		                {showEmploymentType && job.EmploymentTypeName && <li><i class="icon--duration margin-right-1"></i>{job.EmploymentTypeName}</li>}
		                {location && <li><i class="icon--location margin-right-1"></i>{location}</li>}
		            </ul>
		            {showDescription && job.BriefExternal && <p class="single-job__desc" dangerouslySetInnerHTML={{ __html : job.BriefExternal}}></p>}
	            </div>
	        </div>
	        <div class="single-job__right-col">
		        {job.AssignmentLogo && <>
			        {showLink 
			        	? <a href={job.post_url} class={imageLinkClasses}>{image}</a>
			        	: <div class={imageLinkClasses}>{image}</div>
			        }
		        </>}
		    	{showSave && <SavedJobsButton text saved={saved} save={save} unsave={unsave} class="button--negative button--icon-only@medium-max" />}
	        </div>
		</div>
	</>
}